<template>
    <div>
        <a-modal
            class="modalStyle"
            :visible="showRequest"
            :footer="null"
            @cancel="handleCancelRequest"
            >
            <div style="display:flex;justify-content: center;">
                <img class="img_size" src="../../../assets/img/bank.png"/>
            </div>
            <h4 style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;">Make a request?</h4>
            <h4 style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;">{{ amount }}</h4>
            <p style="display:flex;justify-content: center;font-weight: bolder;padding-top: 10px;font-size:20px"> {{ title }} </p>
             <div style="display: flex;justify-content: space-evenly;align-items: center;padding-top:10px;padding-bottom:40px">
                 <a-button @click="handleCancelRequest" style="background: #f50;width:20%;line-height:30px;color:#fff;border-radius:5px;">
                    Cancel
                </a-button>
                <a-button @click="handleConfirmRequest" style="background: #418a49;width:20%;line-height:30px;color:#fff;border-radius:5px;">
                    Proceed
                </a-button>
            </div>
        </a-modal>
    </div>
</template>

<script>
    export default {
        name: "FinanceAction",
        props: ['data','msg', 'payout_amount'],
        data(){
            return{
                payMent: this.data || {},
                title: this.msg,
                amount: this.payout_amount || '',
                showRequest: false
            }
        },
        computed:{
            displayMsg(){
                return this.title
            }
        },
        methods:{
           setVisible(value){
               this.showRequest = value
           },
            handleCancelRequest(){
                this.showRequest =  false
                this.$emit('clickedCancel', false);
            },
            handleConfirmRequest(){
                this.$emit('clicked', this.payMent);
            }
        }
    }
</script>

<style scoped>

.img_size{
    max-width: 56px;
    max-height: 55px;
}
</style>